import { Page } from "./page";
import { Form } from "./form";
import { Element } from "./element";

export class FormPack {
    public item!: Form;
    public children!: PagePack[];
}

export class PagePack {
    public item!: Page;
    public children!: ElementPack[];
}

export class ElementPack {
    public item!: Element;
    public children!: ElementPack[];
}